<template>
    <div class="full-page bg-primary">
        <div class="uk-card uk-card-body uk-card-default uk-position-center" v-if="loggedIn">
            <h1 class="uk-card-title">Kies een Wachtwoord</h1>
            <div class="uk-margin">
                <input class="uk-input" type="password" name="newPassword" v-model="newPassword" placeholder="Nieuw Wachtwoord"/>
            </div>
            <div v-if="error" class="uk-alert-danger">{{error.code}}</div>
            <button class="uk-button uk-button-primary uk-align-right" type="submit" @click.prevent="ChangePassword"><span v-if="!loading">TOEPASSEN</span><div v-if="loading" uk-spinner></div></button>
        </div>
        <div class="uk-card uk-card-body uk-card-default uk-position-center" v-if="warning">
            <h1 class="uk-card-title">Er ging iets fout</h1>
            <div class="uk-margin">
                <p v-if="$store.state.core.user">Je hebt je account nog niet geactiveerd. <br> Dit kan met de link die we naar {{$store.state.core.user.email}} hebben verzonden.</p>
                <p v-else>Je hebt je account nog niet geactiveerd. <br> Dit kan met de link die we naar je email-adress hebben verzonden.</p>
            </div>
            <button class="uk-button uk-button-primary uk-align-right" type="submit" @click.prevent="ChangeAccount">Ander account</button>
        </div>
        <div class="uk-card uk-card-body uk-card-default uk-position-center" v-if="error">
            <h1 class="uk-card-title">Er ging iets fout</h1>
            <div class="uk-margin">
                <p class="uk-text-danger">De link die je hebt gebruikt is niet correct. <br> Gebruik de link die je ontvangen hebt via email.</p>
            </div>
            <button class="uk-button uk-button-primary uk-align-right" type="submit" @click.prevent="ChangeAccount">Ander account</button>
        </div>
    </div>
</template>
<script>
import {db, auth} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'ChangePassword',
        data () {
            return {
                newPassword: '',
                error: null,
                loggedIn: false,
                warning: false,
                loading: false,
            }
        },
        created () {
            if(this.$route.params.email && this.$route.params.pass) {
                auth.signOut()
                auth.signInWithEmailAndPassword(this.$route.params.email, this.$route.params.pass).then(auth => {
                    this.loggedIn = true
                }).catch(error => {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.error = error
                });
            } else {
                if(!auth.currentUser) {
                    this.$router.push('/login')
                } else {
                    this.warning = true
                }
            }
            
        },
        methods: {
            ChangePassword () {
                this.loading = true
                auth.currentUser.updatePassword(this.newPassword).then(auth => {
                    db.collection('users').doc(this.$store.state.core.user.uid).update({firstLogin: false}).then(res => {
                        this.$store.state.core.user.firstLogin = false
                        this.loading = false
                        this.$router.push('/')
                    })
                    
                }).catch(error => {
                    this.loading = false
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.error = error
                    console.log(error)
                });
            },
            ChangeAccount () {
                auth.signOut()
                this.$router.push('/login')
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// FirstLogin.vue?41c8c93c